export const messages = {
    "wre-dashboard.nav-menu.item.shared": "Paylaşım",
    "wre-dashboard.nav-menu.item.backups": "Yedeklemeler",
    "wre-dashboard.nav-menu.item.machines": "Makineler",
    "wre-dashboard.nav-menu.item.account": "Hesap",
    "wre-dashboard.search.input.hint": "Arama",
    "wre-dashboard.search.label.breadcrumb": "Arama sonuçları",
    "wre-dashboard.search.message.empty": "Aramanızla eşleşen öğe yok",
    "wre-dashboard.side-bar.selected.title:plural": "{count} öğe seçildi | {count} öğe seçildi | {count} öğe seçildi",
    "wre-dashboard.side-bar.backup-type.disk": "Disk",
    "wre-dashboard.side-bar.backup-type.file": "Dosya",
    "wre-dashboard.side-bar.backup-type.notarized": "Tasdiklenmiş dosyalar ve klasörler",
    "wre-dashboard.side-bar.backup-type.exchange": "Uygulama - Microsoft Exchange",
    "wre-dashboard.side-bar.backup-type.sql": "Uygulama - Microsoft SQL",
    "wre-dashboard.side-bar.backup-type.sys-state": "Uygulama - Sistem durumu",
    "wre-dashboard.side-bar.backup-type.application": "Uygulama",
    "wre-dashboard.space-indicator.label.left": "{spaceFree} kaldı",
    "wre-dashboard.space-indicator.label.used": "{usedSpace} kullanılan",
    "wre-dashboard.space-indicator.label.unlimited": "Sınırsız",
    "wre-dashboard.backups-table.column.name": "Ad",
    "wre-dashboard.backups-table.column.size": "Boyut",
    "wre-dashboard.backups-table.column.version": "Son yedekleme",
    "wre-dashboard.backups-table.message.no-backups": "Bulutta henüz hiç yedekleme yok",
    "wre-dashboard.backups-sidebar.label.size": "Boyut",
    "wre-dashboard.backups-sidebar.label.type": "Tür",
    "wre-dashboard.backups-sidebar.label.version": "Son sürüm",
    "wre-dashboard.backups-sidebar.label.created": "Oluşturulma",
    "wre-dashboard.backups-sidebar.label.machine": "Makine",
    "wre-dashboard.backups-sidebar.label.owner": "Sahip",
    "wre-dashboard.content-table.column.name": "Ad",
    "wre-dashboard.content-table.column.versions": "Sürümler",
    "wre-dashboard.content-table.column.volumes": "Birimler",
    "wre-dashboard.content-table.column.path": "Yol",
    "wre-dashboard.content-table.column.size": "Boyut",
    "wre-dashboard.content-table.column.version": "Son sürüm",
    "wre-dashboard.content-table.action.versions": "Sürümler",
    "wre-dashboard.content-table.action.restore": "İndir",
    "wre-dashboard.content-table.action.share": "Bağlantı paylaş",
    "wre-dashboard.content-table.label.size": "Boyut",
    "wre-dashboard.content-table.label.created": "Oluşturulma",
    "wre-dashboard.content-table.label.modified": "Değiştirildi",
    "wre-dashboard.content-table.message.empty-folder": "Bu klasör boş",
    "wre-dashboard.password-dialog-box.title.backup": "Şifreli yedekleme",
    "wre-dashboard.password-dialog-box.title.archive": "Şifreli arşiv",
    "wre-dashboard.password-dialog-box.message.backup": "{displayName} yedeklemesine erişmek için lütfen parola belirtin",
    "wre-dashboard.password-dialog-box.message.archive": "{displayName} arşivine erişmek için lütfen parola belirtin",
    "wre-dashboard.password-dialog-box.hint.password": "Şifre",
    "wre-dashboard.password-dialog-box.message.invalid-password": "Parola hatalı",
    "wre-dashboard.form.button.open": "Açma",
    "wre-dashboard.form.button.close": "Kapat",
    "wre-dashboard.form.button.cancel": "İptal",
    "wre-dashboard.form.button.delete": "Sil",
    "wre-dashboard.shared-content-table.column.name": "Ad",
    "wre-dashboard.shared-content-table.column.location": "Konum",
    "wre-dashboard.shared-content-table.column.source": "Kaynak",
    "wre-dashboard.shared-content-table.column.days": "Gün",
    "wre-dashboard.shared-content-table.column.downloads": "İndirmeler",
    "wre-dashboard.shared-content-table.column.shared": "Şu tarihte paylaşıldı:",
    "wre-dashboard.shared-content-table.label.shared": "Şu tarihte paylaşıldı:",
    "wre-dashboard.shared-content-table.label.backup": "Kaynak",
    "wre-dashboard.shared-content-table.action.share": "Bağlantı paylaş",
    "wre-dashboard.shared-content-table.action.settings": "Bağlantı ayarları",
    "wre-dashboard.shared-content-table.action.delete": "Bağlantıyı sil",
    "wre-dashboard.shared-content-table.action.delete-selected": "Bağlantıları sil",
    "wre-dashboard.account-page.message.used-space": "{brandName}: {spaceFree} / {totalSpace} boş",
    "wre-dashboard.account-page.message.used-unlimited-space": "{brandName}: Sınırsız alan",
    "wre-dashboard.account-page.button.sign-out": "Oturumu kapat",
    "wre-dashboard.account-page.button.manage-subscription": "Lisansı yönetin",
    "wre-dashboard.account-page.message.subscription.active": "{brandName} alanı lisansınızın süresi şu tarihte sona erecek:",
    "wre-dashboard.account-page.message.subscription.trial": "{brandName} Deneme Sürümü şu tarihe kadar etkin olacak:",
    "wre-dashboard.account-page.message.subscription.expired": "{brandName} alanı lisansınızın süresi şu tarihte sona erdi:",
    "wre-dashboard.account-page.message.worm-status.storage-full": "{brandName} depolama alanınız dolu. Verileri Buluta yedekleyemez veya arşivleyemezsiniz.",
    "wre-dashboard.account-page.message.worm-status.less-than": "Boş alan yüzde {percent} miktarından daha az. {brandName} ürününü yakında kullanamayacaksınız.",
    "wre-dashboard.versions-dialog-box.title": "{fileName} sürümleri",
    "wre-dashboard.shared-link-dialog-box.share-view.button.copy": "Bağlantıyı kopyala",
    "wre-dashboard.shared-link-dialog-box.share-view.button.manage": "Bağlantı ayarları",
    "wre-dashboard.shared-link-dialog-box.share-view.message": "Bu bağlantıya sahip olan herkes verilerin son sürümünü görüntüleyebilir",
    "wre-dashboard.shared-link-dialog-box.share-view.label.shared": "{creationDate} tarihinde paylaşıldı",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copied": "Bağlantı Kopyalandı",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error": "Bağlantı Kopyalama Hatası",
    "wre-dashboard.shared-link-dialog-box.delete-view.title": "Bağlantıyı sil",
    "wre-dashboard.shared-link-dialog-box.delete-view.message": "Bu bağlantı artık paylaşılan hiç kimsede çalışmayacak",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.title": "Bağlantıları sil",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.message": "Bu bağlantılar artık paylaşılan hiç kimsede çalışmayacak",
    "wre-dashboard.shared-link-dialog-box.manage-view.title": "Bağlantı ayarları",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.delete": "Bağlantıyı sil",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.apply": "Bitti",
    "wre-dashboard.shared-link-dialog-box.manage-view.input.hint.password": "Şifre",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.reset-password": "Şifreyi sıfırla",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.password-protection": "Şifre korumalı",
    "wre-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password": "Bu bağlantıyı bir parola kullanarak koruyun",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.expiration": "Son kullanma tarihi",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.download-limits": "İndirme limitleri",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural": "Bu bağlantıyı {splitMarker} gün içinde devre dışı bırak | Bu bağlantıyı {splitMarker} gün içinde devre dışı bırak | Bu bağlantıyı {splitMarker} gün içinde devre dışı bırak",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural": "Bu bağlantıyı {splitMarker} defa indirildikten sonra devre dışı bırak | Bu bağlantıyı {splitMarker} defa indirildikten sonra devre dışı bırak | Bu bağlantıyı {splitMarker} defa indirildikten sonra devre dışı bırak",
    "wre-dashboard.sub-accounts-dialog-box.title": "Hesaplar",
    "wre-dashboard.sub-accounts-dialog-box.search.input.hint": "Arama",
    "wre-dashboard.sub-accounts-dialog-box.table.message.empty": "Aramanızla eşleşen öğe yok",
    "wre-dashboard.sub-accounts-dialog-box.table.column.name": "Ad",
    "wre-dashboard.sub-accounts-dialog-box.table.column.usage": "Kullanım",
    "wre-dashboard.sub-accounts-dialog-box.table.column.version": "Son yedekleme",
    "wre-dashboard.sub-accounts-dialog-box.table.column.expires": "Sona eriyor",
    "wre-dashboard.sub-accounts-dialog-box.label.used-space": "{spaceFree} şunu içermez {totalSpace}",
    "wre-dashboard.sub-accounts-dialog-box.label.volume-subscription": "Birim aboneliği",
    "wre-dashboard.sub-accounts-dialog-box.label.expired": "Sona erdi",
    "wre-dashboard.machines-table.column.name": "Ad",
    "wre-dashboard.machines-table.column.size": "Boyut",
    "wre-dashboard.machines-table.message.no-machines": "Bulutta henüz hiç makine yok"
};
